import { getAssignmentOptions } from "components/task-list/lib/taskData";
import { useQuery } from "react-query";

export const useGetAssignmentOptions = (taskType) => {
    return useQuery({
        queryKey: ["assignment-options"],
        // initialData: [],
        queryFn: () => getAssignmentOptions(taskType),
    });
};
